import { DownArrow } from 'assets'
import { useOutsideClick } from 'Hooks'
import React, { useState } from 'react'

function DropDown(props) {
   const { option, value, onChangeOpt } = props
   const [recentDropDown, setRecentDropDown] = useState(false)
   const ref = useOutsideClick(() => setRecentDropDown(false))
   return (
      <div className="channel-dropdown-section" ref={ref}>
         <div className="channel-dropdown" onClick={() => setRecentDropDown(!recentDropDown)}>
            <div className="channel-name">{value}</div>
            <DownArrow />
         </div>
         {recentDropDown && (
            <ul className="channal-list">
               {option &&
                  option?.length > 0 &&
                  option.map((item, i) => {
                     return (
                        <li
                           key={i}
                           className={`${item?.value === value ? 'active' : ''}`}
                           onClick={() => {
                              setRecentDropDown(!recentDropDown)
                              onChangeOpt(item?.value)
                           }}>
                           {item?.label}
                        </li>
                     )
                  })}
            </ul>
         )}
      </div>
   )
}

export default DropDown
